import { css } from '@emotion/react'
import { memo } from 'react'

export const HomeIcon = memo(() => (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		css={css`
			display: block;
		`}
	>
		<path
			d="M22.8333 8.6233L16.6377 4.35425C15.0749 3.21525 12.9358 3.21525 11.3731 4.35425L5.16642 8.6233C3.74775 9.65278 2.9165 11.2846 2.9165 13.026V22.2365C2.9165 23.0798 3.28225 23.9012 3.914 24.5036C4.53467 25.095 5.36592 25.4126 6.2415 25.4126H9.5665C10.1761 25.4126 10.6748 24.9197 10.6748 24.3174V19.2028C10.6748 18.6005 11.1736 18.1077 11.7832 18.1077H16.2165C16.8261 18.1077 17.3248 18.6005 17.3248 19.2028V24.3174C17.3248 24.9197 17.8236 25.4126 18.4332 25.4126H21.7582C22.6338 25.4126 23.465 25.095 24.0857 24.5036C24.7174 23.9122 25.0832 23.0908 25.0832 22.2365V13.026C25.0832 11.2846 24.2519 9.65278 22.8333 8.6233Z"
			stroke="currentColor"
			strokeWidth="2.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
))
